/**
 * MSAL Configuration for NPSF Tenant Authentication
 * Used to protect the migrate-account page
 */

import { Configuration, LogLevel } from '@azure/msal-browser';


/**
 * MSAL configuration object for NPSF/Athena Users CIAM Tenant
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env?.VITE_NPSF_CLIENT_ID! ?? '',
    authority: `https://login.microsoftonline.com/${import.meta.env?.VITE_NPSF_TENANT_ID! ?? ''}`,
    redirectUri: window.location.origin + '/athena/migrate-account',
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};